module.exports = __webpack_public_path__ + "img/times.faf3ca94.svg";